export const btnStyle = {
    "&:hover": {
        color:"red", cursor: "pointer",
    },
}

export const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  }
  
 export const backImage = {
     backgroundPosition: "center",
     position: "absolute",
     bottom:50,
     left: 10,
     height: "150px",
     with: "auto",
 } 
 
 